import { Component, Injector } from '@angular/core';
import {
  MessageService,
  LoaderService,
  ValidationResultService,
} from '@shared';
import { CategoryService, AlertsService, ItemService } from '@shared-data';
import { GridRowLtoChangeset } from '../../models';
import { RestaurantItemService } from '../../services';
import { BasePricingChangesetComponent } from '../base-pricing-changeset/base-pricing-changeset.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-lto-changeset',
  templateUrl: './lto-changeset.component.html',
  styleUrl: './lto-changeset.component.scss',
})
export class LtoChangesetComponent extends BasePricingChangesetComponent {
  constructor(
    validationErrorService: ValidationResultService,
    messageService: MessageService,
    loaderService: LoaderService,
    categoryService: CategoryService,
    restaurantItemsService: RestaurantItemService,
    activatedRoute: ActivatedRoute,
    injector: Injector,
    private itemService: ItemService,
  ) {
    super(
      validationErrorService,
      messageService,
      loaderService,
      restaurantItemsService,
      categoryService,
      activatedRoute,
      injector,
      GridRowLtoChangeset,
    );
  }
  override ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.changeset.total > 0)
      this.globalEventsService.onNavigateAwayFromLTO();
  }

  override setInitialSort(): void {
    this.initialSort = [
      { field: 'itemName', dir: 'asc' },
      { field: 'itemType', dir: 'asc' },
    ];
  }

  override setInitialFilter(): void {
    this.initialFilter = {
      logic: 'and',
      filters: [
      ]
    };
  }

  downloadDocument(
    newItem: { itemName: string; parItemId: string },
    documentPath: string,
  ) {
    this.itemService.downloadDocument(documentPath).subscribe({
      next: async (response: { url: string }) => {
        const downloadLink = document.createElement('a');
        downloadLink.target = '_blank';
        downloadLink.href = response.url;
        downloadLink.download = `${newItem.itemName}_${newItem.parItemId}.pdf`; // Suggest a filename
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      },
      error: (error) => {
        this.messageService.error('Error downloading document');
        var validationError = error?.error;
        if (validationError) this.validationErrorService.show(validationError);
      },
    });
  }
}
